import { useState } from "react"
import { router } from "@inertiajs/react"
import { ChevronDown } from "lucide-react"
import { Button } from "@/components/ui/Button"
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/DropdownMenu"
import AddProductDialog from "./AddProductDialog"
import { seed_warehouse_channel_products_path } from "@/lib/routes"
import { useMarket } from "@/lib/useMarket"

interface Props {
  orgNodeId: string
  warehouseId: string
  existingExternalIds: Set<string>
}

// Split header button: add a product, or seed the list from the dropdown.
export default function ProductActions({ orgNodeId, warehouseId, existingExternalIds }: Props) {
  const [adding, setAdding] = useState(false)
  const market = useMarket()

  function seed() {
    router.post(seed_warehouse_channel_products_path(market.slug), {
      org_node_id: orgNodeId,
      warehouse_id: warehouseId,
    })
  }

  return (
    <>
      <div className="inline-flex items-stretch">
        <Button size="sm" className="rounded-r-none pr-4" onClick={() => setAdding(true)}>
          + Add product
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              size="sm"
              aria-label="More product options"
              className="rounded-l-none border-l border-primary-foreground/30 px-2.5 focus-visible:ring-0 focus-visible:ring-offset-0"
            >
              <ChevronDown className="size-3" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[18rem]">
            <DropdownMenuLabel>Other options</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={seed} className="flex flex-col items-start gap-0.5 py-2">
              <span className="text-sm font-medium">Seed products</span>
              <span className="text-xs text-muted-foreground">
                Fill the list from recent sales and current inventory.
              </span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {adding && (
        <AddProductDialog
          orgNodeId={orgNodeId}
          warehouseId={warehouseId}
          existingExternalIds={existingExternalIds}
          onClose={() => setAdding(false)}
        />
      )}
    </>
  )
}
